function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

function getYesterday0Time() {
    let day = new Date();
    day.setDate(day.getDate() - 1);
    return dateFormat("YYYY-mm-dd", day);
}


function getDay0Time() {
    let day = new Date();
    
    return dateFormat("YYYY-mm-dd", day);
}

function getDay24Time() {
    let day = new Date();
    day.setDate(day.getDate() + 1);
    return dateFormat("YYYY-mm-dd", day);

}

function getStartTime(time) {
    let nowTimeDate = new Date(time)
    return nowTimeDate.setHours(0, 0, 0, 0)
}

function getEndTime(time) {
    let nowTimeDate = new Date(time)
    return nowTimeDate.setHours(23, 59, 59, 999)
}

export default {
    dateFormat, getYesterday0Time,  getDay0Time, getDay24Time, getStartTime, getEndTime
}


// WEBPACK FOOTER //
// ./src/utils/timeUtils.js